function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.024 10.8679C19.024 10.8679 17.6445 11.3417 17.3347 11.6713C17.3347 11.6713 17.286 12.3517 16.7717 12.8466C16.3431 13.2588 15.4014 13.5849 15.4014 13.5849C15.4014 13.5849 15.5516 11.4432 19.024 10.8679ZM39.8539 18.6365C39.74 17.9831 39.5551 17.3794 39.3197 16.8225C38.7736 15.5296 37.9537 14.4926 37.1065 13.684C36.2634 12.8793 35.3945 12.3012 34.7408 11.9274C34.1029 11.5628 33.6701 11.3909 33.6701 11.3909C33.6818 11.3878 33.6937 11.3856 33.7054 11.3827C34.1178 11.2803 34.5405 11.2722 34.9409 11.3144C35.9246 11.4182 36.7676 11.8304 36.9563 11.9279C36.982 11.9412 36.9958 11.9489 36.9958 11.9489C36.4864 11.2772 35.9114 10.6917 35.3111 10.1803C32.5436 7.82294 29.2299 7.0741 29.2299 7.0741C29.2488 7.06456 29.2694 7.05613 29.2896 7.04733C30.3071 6.60433 32.9129 7.0741 32.9129 7.0741C32.8954 7.06197 32.8777 7.05011 32.86 7.03807C29.3481 4.62391 24.0474 4.17997 24.0474 4.17997C18.4275 0.402054 19.9051 -1.17306 18.704 0.958892C18.0545 2.11175 18.0594 3.1842 18.2665 4.02307C18.1482 4.10467 18.1426 4.10847 18.0243 4.19007C16.271 3.01369 13.7493 1.49758 14.3369 2.34497C14.7831 2.98859 15.2347 4.77173 15.5209 6.07407C11.2545 10.3388 13.0695 13.8145 13.0695 14.4939C13.0695 15.2277 8.98657 20.12 8.98657 20.12C8.99121 20.1259 8.99594 20.1315 9.00058 20.1376C9.00104 20.1381 9.0015 20.1387 9.00197 20.1393C9.03481 20.1787 9.13805 20.3024 9.30279 20.4997C9.37756 20.5838 9.45316 20.6648 9.52931 20.7439C12.2199 23.4845 15.698 22.1251 17.8286 20.8143C20.0327 19.4582 22.9564 19.9356 24.4852 22.0219C24.6023 22.1815 24.7193 22.3585 24.8329 22.5518C25.715 24.0523 25.7852 26.0118 25.1999 27.9239C23.2195 34.3944 15.1344 36.447 10.006 32.0248C7.86351 30.1772 6.70316 27.9684 6.0902 26.3363C5.19477 23.5506 4.71882 20.6044 4.71882 17.5846V14.7189L11.1122 11.9667C11.0806 11.261 11.1498 10.3651 11.4583 9.32516C11.7543 8.32689 12.2707 7.1959 13.1321 5.97163L0.00488281 11.6224V17.5846C0.00488281 29.8765 6.74657 41.1336 17.5987 46.9627L19.5291 48L21.4594 46.9627C31.7634 41.4281 38.3581 30.9997 38.9984 19.4391C39.0281 18.9025 39.0457 18.3635 39.0495 17.8222L39.0458 17.8206C39.046 17.8202 39.0462 17.8196 39.0463 17.8192C39.5513 18.2559 39.8539 18.6365 39.8539 18.6365Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 9,
  y: 19,
  width: 1,
  height: 2
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.06152 19.9243C9.35672 20.2546 9.65892 20.556 9.96718 20.83C9.83639 20.7115 9.70656 20.5901 9.57816 20.4641C9.29523 20.1686 9.11792 19.9833 9.06152 19.9243Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.06152 19.9243C9.35672 20.2546 9.65892 20.556 9.96718 20.83C9.83639 20.7115 9.70656 20.5901 9.57816 20.4641C9.29523 20.1686 9.11792 19.9833 9.06152 19.9243Z",
  fill: "url(#paint0_linear)"
}));

var _ref5 = /*#__PURE__*/React.createElement("mask", {
  id: "mask1",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 19,
  y: 0,
  width: 4,
  height: 6
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.1728 4.28237C20.4398 3.38659 19.5018 0.905762 19.5018 0.905762C18.5636 2.76629 19.2954 4.28237 19.2954 4.28237C20.4072 6.34966 23.9058 5.17823 22.1728 4.28237Z",
  fill: "white"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.1728 4.28237C20.4398 3.38659 19.5018 0.905762 19.5018 0.905762C18.5636 2.76629 19.2954 4.28237 19.2954 4.28237C20.4072 6.34966 23.9058 5.17823 22.1728 4.28237Z",
  fill: "#C1B9D3"
}));

var _ref7 = /*#__PURE__*/React.createElement("mask", {
  id: "mask2",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 25,
  y: 6,
  width: 8,
  height: 2
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.3635 6.6647C25.3635 6.6647 27.7763 7.12387 28.9614 7.2122C28.9886 7.21423 29.018 7.21697 29.0482 7.21998C30.048 6.79747 32.6088 7.2455 32.6088 7.2455C32.5916 7.23393 32.5742 7.22263 32.5568 7.21114C29.5006 5.64832 25.3635 6.6647 25.3635 6.6647Z",
  fill: "white"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask2)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.3635 6.6647C25.3635 6.6647 27.7763 7.12387 28.9614 7.2122C28.9886 7.21423 29.018 7.21697 29.0482 7.21998C30.048 6.79747 32.6088 7.2455 32.6088 7.2455C32.5916 7.23393 32.5742 7.22263 32.5568 7.21114C29.5006 5.64832 25.3635 6.6647 25.3635 6.6647Z",
  fill: "#C1B9D3"
}));

var _ref9 = /*#__PURE__*/React.createElement("mask", {
  id: "mask3",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 28,
  y: 9,
  width: 9,
  height: 3
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.1038 9.0736C26.4083 8.83429 33.0621 11.207 33.0621 11.207C33.0621 11.207 33.0735 11.2093 33.0937 11.2133C33.4888 11.1087 33.8938 11.1004 34.2774 11.1435C35.2198 11.2495 36.0274 11.6703 36.2082 11.7698C36.2159 11.7712 36.2237 11.7724 36.2316 11.7736C36.2316 11.7736 33.7993 9.31291 30.1038 9.0736Z",
  fill: "white"
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask3)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.1038 9.0736C26.4083 8.83429 33.0621 11.207 33.0621 11.207C33.0621 11.207 33.0735 11.2093 33.0937 11.2133C33.4888 11.1087 33.8938 11.1004 34.2774 11.1435C35.2198 11.2495 36.0274 11.6703 36.2082 11.7698C36.2159 11.7712 36.2237 11.7724 36.2316 11.7736C36.2316 11.7736 33.7993 9.31291 30.1038 9.0736Z",
  fill: "#C1B9D3"
}));

var _ref11 = /*#__PURE__*/React.createElement("mask", {
  id: "mask4",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 34,
  y: 15,
  width: 6,
  height: 5
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.9818 18.2468C38.982 18.2464 38.9822 18.2458 38.9823 18.2453C39.5274 18.698 39.8541 19.0926 39.8541 19.0926C39.8541 19.0926 38.4888 15.7937 34.4202 15.3962L38.9306 19.9245C38.9627 19.3683 38.9817 18.8096 38.9858 18.2485L38.9818 18.2468Z",
  fill: "white"
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask4)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.9818 18.2468C38.982 18.2464 38.9822 18.2458 38.9823 18.2453C39.5274 18.698 39.8541 19.0926 39.8541 19.0926C39.8541 19.0926 38.4888 15.7937 34.4202 15.3962L38.9306 19.9245C38.9627 19.3683 38.9817 18.8096 38.9858 18.2485L38.9818 18.2468Z",
  fill: "#C1B9D3"
}));

var _ref13 = /*#__PURE__*/React.createElement("mask", {
  id: "mask5",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 9,
  y: 19,
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.1013 19.9629C9.10195 19.9638 9.10638 19.9693 9.11414 19.9782C9.10869 19.9717 9.10148 19.9632 9.1013 19.9628C9.1013 19.9628 9.1013 19.9628 9.1013 19.9629Z",
  fill: "white"
}));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask5)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.1013 19.9629C9.10195 19.9638 9.10638 19.9693 9.11414 19.9782C9.10869 19.9717 9.10148 19.9632 9.1013 19.9628C9.1013 19.9628 9.1013 19.9628 9.1013 19.9629Z",
  fill: "url(#paint1_linear)"
}));

var _ref15 = /*#__PURE__*/React.createElement("mask", {
  id: "mask6",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 8,
  y: 20,
  width: 2,
  height: 1
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.99934 20.1363C8.9999 20.137 9.001 20.1384 9.00174 20.1392C9.00128 20.1386 9.00082 20.138 9.00036 20.1375C9.00008 20.1372 8.99962 20.1366 8.99934 20.1363Z",
  fill: "white"
}));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask6)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.99934 20.1363C8.9999 20.137 9.001 20.1384 9.00174 20.1392C9.00128 20.1386 9.00082 20.138 9.00036 20.1375C9.00008 20.1372 8.99962 20.1366 8.99934 20.1363Z",
  fill: "url(#paint2_linear)"
}));

var _ref17 = /*#__PURE__*/React.createElement("mask", {
  id: "mask7",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 2,
  y: 9,
  width: 32,
  height: 34
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.8759 42.4021C19.9067 42.4453 19.9254 42.4705 19.9254 42.4705L20.5903 42.1134C22.5662 41.006 29.5955 35.1596 30.8772 29.8727C33.1415 20.5333 27.8002 18.9696 27.8002 18.9696C32.251 19.1211 33.9373 23.1611 33.9373 23.1611C33.9373 23.1611 33.1614 17.1011 27.598 15.5355C22.0345 13.97 19.4551 18.2121 14.9538 20.1201C10.6995 21.9233 9.15702 20.3193 9.00035 20.1376C9.00081 20.1381 9.00128 20.1387 9.00174 20.1393C9.03458 20.1787 9.13782 20.3025 9.30257 20.4997C9.37733 20.5838 9.45293 20.6649 9.52909 20.744C12.2196 23.4845 15.6978 22.1251 17.8283 20.8144C20.0324 19.4582 22.9562 19.9357 24.485 22.022C24.602 22.1816 24.7191 22.3586 24.8326 22.5519C25.7148 24.0523 25.785 26.0118 25.1997 27.924C23.2192 34.3945 15.1342 36.447 10.0058 32.0249C7.86329 30.1772 6.70294 27.9684 6.08997 26.3363C5.19455 23.5506 4.71859 20.6044 4.71859 17.5846V14.719L11.112 11.9667C11.0803 11.2611 11.1495 10.3651 11.4581 9.3252L2.53926 12.9803C2.53926 12.9803 -0.344589 37.7247 19.8759 42.4021Z",
  fill: "white"
}));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask7)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.484 41.861C22.4599 40.7537 29.5937 35.1596 30.8753 29.8727C33.1396 20.5333 27.7984 18.9696 27.7984 18.9696C32.2491 19.1211 33.9354 23.1611 33.9354 23.1611C33.9354 23.1611 33.1595 17.1011 27.5961 15.5355C22.0326 13.9701 19.4532 18.2121 14.9519 20.1201C10.6977 21.9233 9.15515 20.3193 8.99847 20.1376C8.99894 20.1382 8.9994 20.1387 8.99986 20.1394C9.0327 20.1787 9.13594 20.3025 9.30069 20.4997C9.37545 20.5838 9.45105 20.6649 9.52721 20.744C12.2177 23.4846 15.6959 22.1252 17.8265 20.8144C20.0306 19.4582 22.9543 19.9357 24.4831 22.022C24.6002 22.1816 24.7172 22.3586 24.8308 22.5519C25.7129 24.0523 25.7831 26.0118 25.1978 27.924C23.2174 34.3945 15.1323 36.4471 10.0039 32.0249C7.86141 30.1773 6.70106 27.9684 6.08809 26.3364C5.19267 23.5506 4.71671 20.6044 4.71671 17.5846V14.719L11.1101 11.9667C11.0785 11.2611 11.1477 10.3651 11.4562 9.3252L2.53738 12.9803C2.53738 12.9803 -1.00398 37.6919 19.2166 42.3693C19.419 42.4705 20.484 41.861 20.484 41.861Z",
  fill: "#C1B9D3"
}));

var _ref19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: -14.85,
  y1: -8.88258,
  x2: -21.397,
  y2: 46.0418,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: -7.41407,
  y1: 1.04705,
  x2: -11.2111,
  y2: 37.6249,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 0.414164,
  y1: 2.03227,
  x2: -1.73498,
  y2: 22.7385,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080"
})));

var SvgShukiWhite = function SvgShukiWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShukiWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shuki-white.a563de3f.svg";
export { ForwardRef as ReactComponent };